module.exports = __webpack_public_path__ + "img/rubber2.758807b5.svg";